export default "__VITE_ASSET__BUwfni2L__"